import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { Menu } from '../../views/twig/components/Menu';
import { Filters } from '../twig/components/Filters';
import { FrontPage } from '../twig/pages/front-page';
import { SingleProject } from '../twig/pages/single-project';
/*(new Carousel()).init();
(new Collapse()).init();
(new Demo()).init();
(new Dropdown()).init();
(new ScrollSpy()).init();*/
(new Menu()).init();
(new LazyLoader()).init();
(new SingleProject()).init();
(new Filters()).init();
(new FrontPage()).init();
